 const AuthBtnSpinner = ({ cls, loader }) => {
  return (
    <button className="theme-btn btn w-100" type="button" disabled>
      Loading...
    </button>
  );
};


export default AuthBtnSpinner;